<script>
  import { Router, Link, Route } from "svelte-routing";
  import Header from "./components/Header.svelte";
  import Home from "./pages/Home.svelte";
  import About from "./pages/About.svelte";
  import GalleryModels from "./galleries/GalleryModels.svelte";
  import GalleryWebsites from "./galleries/GalleryWebsites.svelte";
  import GalleryGraphics from "./galleries/GalleryGraphics.svelte";
  import GalleryTools from "./galleries/GalleryTools.svelte";
  import NotFound from "./pages/NotFound.svelte";
  import Modal from './components/Modal.svelte';
  
  export let url = "";
</script>

<Router url="{url}">
  <Header></Header>
  <div>
    <!--<Route path="blog/:id" component="{BlogPost}" />-->
    <Route path="about"><About /></Route>
    <Route path="gallery-models/:category" let:params>
      <Modal>
        <GalleryModels category={params.category} />
      </Modal>
    </Route>
    <Route path="gallery-models">
      <Modal>
        <GalleryModels />
      </Modal>
    </Route>
    <Route path="gallery-websites"><GalleryWebsites /></Route>
    <Route path="gallery-graphics">
      <Modal>
        <GalleryGraphics />
      </Modal>
    </Route>
    <Route path="gallery-tools">
      <Modal>
        <GalleryTools />
      </Modal>
    </Route>

    <Route path="/home"><Home /></Route>
    <Route path="/"><Home /></Route>
    <Route component="{NotFound}" />
  </div>
</Router>